
import {computed, defineComponent, onMounted, reactive, Ref, ref, toRefs, watch} from 'vue'
import {
  inject,
} from 'vue'
import NavigationTabBar from '@/layouts/components/NavigationTabBar.vue'

export default defineComponent({
  name: 'NavigationTabBarItem',
  props: {
    name: {
      type: [Number, String],
      required: true,
    }
  },
  emits: ['tabClick'],
  setup (props, context) {

    const state = reactive<{
      item: HTMLAnchorElement | null
    }>({
      item: null
    })

    const {initialiseTabAsCurrent, currentTab, setCurrentTab} = inject<{
      initialiseTabAsCurrent: Ref<InstanceType<typeof NavigationTabBar>['$props']['modelValue']>,
      currentTab: Ref<number | string | undefined>,
      setCurrentTab: ((_: any, __: any) => void) | null
    }>(
      'currentTab', {
        initialiseTabAsCurrent: ref(undefined),
        currentTab: ref(undefined),
        setCurrentTab: null
      }
    )

    const active = computed(
      () => currentTab && (currentTab.value === undefined || props.name === currentTab?.value)
    )

    watch(active, (newValue) => {
      if (newValue && setCurrentTab !== null) {
        setCurrentTab(props.name, state.item)
      }
    })

    const tabClick = () => {
      context.emit('tabClick', props.name)
      if (setCurrentTab !== null) {
        setCurrentTab(props.name, state.item)
      }
    }

    const initialiseCheck = () => {
      if (initialiseTabAsCurrent.value && initialiseTabAsCurrent.value === props.name && setCurrentTab) {
        setCurrentTab(initialiseTabAsCurrent.value, state.item)
      } else if (!initialiseTabAsCurrent.value && currentTab.value === props.name && setCurrentTab) {
        setCurrentTab(props.name, state.item)
      }
    }

    onMounted(initialiseCheck)

    watch(initialiseTabAsCurrent, initialiseCheck)

    return {
      ...toRefs(state),
      active,
      setCurrentTab,
      tabClick,
    }
  }
})
